var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/_core.js
 ** module id = 22
 ** module chunks = 0
 **/